import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalTypeList extends BaseModelAPI {

	static entity = 'approvaltypelist'
	static entityName = 'approvaltype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
